import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import * as _ from "lodash";
import { LogisticsInventoryCurrentBalances } from "src/app/services/service/DataProviders/LogisticsInventoryCurrentBalances";
import { ProductionTechnologiesRecipes } from "src/app/services/service/DataProviders/ProductionTechnologiesRecipes";
import { RecipeTree } from "./recipe-tree";

@Component({
  selector: "subproducts-tree",
  templateUrl: "./subproducts-tree.component.html",
  styleUrls: ["./subproducts-tree.component.scss"],
})
export class SubproductsTreeComponent {
  @Input() po;
  @Input() recepiesToProcess;
  @Input() parent: any;
  @Input() allowQuantityChange: boolean = false;

  public treeForView;

  private recipeObjectStructure = {
    processed: false,
    product: null,
    recipe: null,
    ingredients: [],
  };

  public tree = [];

  constructor(
    private recepieService: ProductionTechnologiesRecipes,
    private availabilityService: LogisticsInventoryCurrentBalances,
    ) { }

  ngOnInit() {
    if (_.isEmpty(this.parent.tree)) {
      this.addRecipesAndBuildTree();
    }
    else {
      this.tree = this.parent.tree;
      this.treeForView = [];
      this.buildTreeForView();
    }
  }

  async quantityChanged(node) {
    //когато се смени количеството се преизчислява цялото дърво под текущият възел
    //най-горното ниво не може да се промени защото то е част от основното ПН
    const quantity = node.node.quantity;
    for (const n of node.childrens) {
      this.updateChildren(n, quantity)
    }
  }

  updateChildren(node, quantity) {
    node.node.setNewQuantity(quantity);
    for (const n of node.childrens) {
      this.updateChildren(n, node.node.quantity);
    }
  }

  async addRecipesAndBuildTree() {
    this.tree = [];
    this.treeForView = [];
    for (let i = 0; i < this.recepiesToProcess.length; i++) {
      let recipe = this.recepiesToProcess[i].Recipe;
      let quantity = _.get(
        this.recepiesToProcess[i],
        "ProducedQuantityBase.Value"
      );

      this.tree[i] = new RecipeTree(this.recepieService, this.availabilityService);
      this.tree[i].setRootPo(this.po);
      await this.tree[i].init(recipe.Product, quantity);
    }

    this.buildTreeForView();
    this.parent.tree = this.tree;
  }

  buildTreeForView() {
    for (let i = 0; i < this.tree.length; i++) {
      let tree = this.tree[i];
      let maxLevel = tree.maxLevel;
      let rootNode = tree.getNodesOnLevel(0)[0];

      this.treeForView[i] = this.buildTree(rootNode, maxLevel);
    }
    // console.log(this.treeForView);
  }

  buildTree(n, maxLevel) {
    let self = this;
    let node = {
      node: n,
      childrens: [],
    };

    if (n.level > maxLevel) {
      return [];
    }

    let tree = n.tree.tree;
    let level = n.level + 1;

    tree.forEachLinkedNode(n, function (linkedNode, link) {
      if (linkedNode.id.level == level) {
        node.childrens.push(self.buildTree(linkedNode.id, maxLevel));
      }
    });

    return node;
  }

  getChildrens = (node) => node.childrens;
}
